import Vue from 'vue';
import Buefy from 'buefy';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import VueMeta from 'vue-meta';
import {
  formatNombre, getImg, formatDate, getImgPanneau, getImgAltPanneau,
} from '@/services/general/general';
import App from './App';
import './assets/scss/app.scss';
import router from './router';
import store from './store/store';

Vue.use(Buefy);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCv-YvtnpWFMggWL7BoyahVNxgVPZA9qsE',
    libraries: 'places',
  },
});

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.component('GmapCluster', GmapCluster);

Vue.mixin({
  methods: {
    formatNombre(val) {
      return formatNombre(val);
    },
    getImg(img) {
      return getImg(img);
    },
    formatDate(date) {
      return formatDate(date);
    },
    getImgPanneau(img) {
      return getImgPanneau(img);
    },
    getImgAltPanneau(img) {
      return getImgAltPanneau(img);
    },
    errorToast(error, msg, position = 'is-top') {
      let messages = [error.message];
      if (error.response && error.response.data) {
        if (error.response.data.errors) {
          messages = [];
          error.response.data.errors.forEach(err => {
            messages.push(err.msg);
          });
        }
        if (error.response.data.message) {
          messages = [error.response.data.message];
        }
      }
      if (msg) messages = [msg];
      let message = '';
      if (messages.length) {
        message = '<div class="content"><ul class="is-marginless">';
        messages.forEach(msg => {
          message += `<li>${msg}</li>`;
        });
        message += '</ul></div>';
      }
      if (message) {
        this.$buefy.toast.open({
          duration: 5000,
          message,
          position,
          type: 'is-danger',
        });
      }
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
